
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adobe-target",
      function () {
        return require("private-next-pages/destinations/adobe-target.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adobe-target"])
      });
    }
  